execResult